/**
 * Default data objects for tables and forms
 */

// Default recruit data structure with empty values
export const defaultRecruitData = {
    code: '',
    status: 'A',
    first_name: '',
    last_name: '',
    phone_number: '',
    email: '',
    linkedin: '',
    FB_IG: '',
    NDA_date: 'No',
    company: '',
    team: '',
    department: '',
    division: '',
    position: '',
    date_of_interview: '',
    date_of_translate: '',
    commentary: '',
    date_of_offer: '',
    date_of_fired: '',
    P01divisor: 1,
    P01_0: 0,
    P01_1: 0,
    P01_2: 0,
    P01_3: 0,
    P01_4: 0,
    P02divisor: 0,
    P02_0: 0,
    P02_1: 0,
    P03divisor: 0,
    P03_0: 0,
    P03_1: 0,
    P04divisor: 0,
    P04_0: 0,
    P04_1: 0,
    P05divisor: 0,
    P05_0: 0,
    P05_1: 0,
    P06divisor: 0,
    P06_0: 0,
    P06_1: 0,
    P07divisor: 0,
    P07_0: 0,
    P07_1: 0,
    P07_2: 0,
    P08divisor: 0,
    P08_0: 0,
    P08_1: 0,
    P09divisor: 0,
    P09_0: 0,
    P09_1: 0,
    P10divisor: 0,
    P10_0: 0,
    P10_1: 0,
    P11divisor: 0,
    P11_0: 0,
    P11_1: 0,
  };
  
  // Default column conditions for dynamic P/F columns
  export const defaultColumnConditions = {
    lower: { value: 35, condition: "<" },
    upper: { value: 80, condition: ">" },
    colorOption: null,
  };
  
  // Create a function to generate default column conditions for all P/F columns
  export const generateDefaultColumnConditions = () => {
    const conditions = {};
    
    // P columns
    for (let i = 1; i <= 11; i++) {
      const baseId = `P${i.toString().padStart(2, '0')}`;
      
      // P columns with _0, _1, etc. suffixes
      for (let j = 0; j <= 4; j++) {
        const columnId = `${baseId}_${j}`;
        conditions[columnId] = { ...defaultColumnConditions };
      }
    }
    
    // F columns
    for (let i = 1; i <= 12; i++) {
      const columnId = `F${i}`;
      conditions[columnId] = { ...defaultColumnConditions };
    }
    
    return conditions;
  };
  
  // Default initial filter state
  export const defaultFilters = {
    filter: '',
    company: '',
    team: '',
    department: '',
    position: '',
    rating: '',
  };
  
  // Default table pagination
  export const defaultPagination = {
    currentPage: 1,
    rowsPerPage: 10000,
    totalPages: 1,
    totalItems: 0,
  };